import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { WINDOW } from '@ng-web-apis/common';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { baseUrl } from '../utils/helpers';

@Injectable()
export class MetadataService {
  constructor(
    private meta: Meta,
    private title: Title,
    @Inject(I18NEXT_SERVICE) private translateService: ITranslationService,
    @Inject(WINDOW) private window: Window,
    @Inject(DOCUMENT) private document: Document,
    @Optional() @Inject('CANONICAL_URL') private canonicalURL: string,
  ) {}

  setTitle(title?: string) {
    const tTitle = this.translateService.t('meta.title');
    this.title.setTitle(title ? this.translateService.t(title) : tTitle);
  }

  setDescription(description?: string) {
    const tDesc = this.translateService.t('meta.description');
    this.meta.updateTag({
      name: 'description',
      content: this.translateService.t(description) || tDesc,
    });
  }

  clean() {
    // TO DO TUT QUANT OG
    this.setTitle();
    this.setDescription();
  }

  setTags(tags: { property: string; content: string }[]) {
    tags.forEach(tag => {
      this.meta.updateTag({ property: tag.property, content: tag.content });
    });
  }

  setAlternate(lang: 'it' | 'en' | 'es' | 'fr' | 'de' | 'x-default', url: string) {
    const link = this.document.querySelector(`link[rel='alternate'][hreflang='${lang}']`);
    if (link) {
      link.setAttribute('href', url);
    }
  }

  createCanonicalUrl(url: string) {
    if (this.canonicalURL) {
      this.meta.updateTag({ rel: 'canonical', href: this.canonicalURL });
    }
    // const links = this.document.querySelectorAll(`link[rel='canonical']`);
    // if (links) links.forEach(l => l.remove());
    // const link: HTMLLinkElement = this.document.createElement('link');
    // link.setAttribute('rel', 'canonical');
    // this.document.head.appendChild(link);
    // link.setAttribute('href', this.getBaseUrl() + url);
  }

  private getBaseUrl(): string {
    return this.window?.location?.origin || baseUrl;
  }

  setMetadataPage(page: string, location: string) {
    this.setTitle(page + '.metadata.title');
    this.setDescription(page + '.metadata.description');
    this.setTags([
      { property: 'og:url', content: baseUrl + location },
      { property: 'og:title', content: this.translateService.t(page + '.metadata.title') },
      {
        property: 'og:description',
        content: this.translateService.t(page + '.metadata.description'),
      },
      { property: 'og:image', content: 'https://media.sharry.land/app/images/meta/' + page + '.webp' },
      { property: 'og:image:url', content: 'https://media.sharry.land/app/images/meta/' + page + '.webp' },
      { property: 'og:image:width', content: '600' },
      { property: 'og:image:height', content: '600' },
      { property: 'og:image:type', content: 'image/*' },
    ]);
  }
}

export const METADATA_SERVICE = new InjectionToken<MetadataService>('metadata');
